/**
 * @file index.tsx
 *
 * @fileoverview Order item quantity selector.
 */
import React from 'react';
import { CommerceOrderItem } from '~/jobiqo/types/types';
import { Select } from '~/vcl/atoms/01-forms/05-select';
import { SelectItem } from '~/vcl/models/forms';
import { useConfig } from '~/jobiqo/context/config';

interface OrderItemQuantitySelectorProps {
  /**
   * The order item to add selection to.
   */
  orderItem: CommerceOrderItem;
  /**
   * When a product is selected, this callback is called.
   */
  onChange: (quantity: SelectItem) => void;
}
export const OrderItemQuantitySelector = ({
  orderItem,
  onChange,
}: OrderItemQuantitySelectorProps) => {
  if (orderItem.product.type === 'subscription') {
    return null;
  }

  const { getConfigByName } = useConfig();
  const MAX_QUANTITY: number = (getConfigByName('max_quantity')
    ?.value[0] as unknown) as number;

  return (
    <Select
      selectedValue={orderItem.quantity.toString()}
      items={Array.from({ length: MAX_QUANTITY ?? 10 }, (_, i) => i + 1).map(
        (item) => {
          return {
            name: item.toString(),
            code: item.toString(),
          };
        },
      )} // This could be better.
      onChange={onChange}
    />
  );
};
